import { cloneDeep } from "lodash";

export const formatList = (list = []) => {
    const newList = cloneDeep(list);
    newList.forEach((item, index) => {
        item.index = index + 1;
        item.isFirst = index == 0 ? true : false;
        item.isLast = (index+1) == newList.length ? true : false;
        if (item.list && item.list.length) {
            (item.list || []).forEach((el,index) => {
                el.index = index + 1;
                el.isFirst = index == 0 ? true : false;
                el.isLast = (index+1) == item.list.length ? true : false;

            });
        }
        
    });
    return newList
};

export const searchByKeyword = (keyword, list = []) => {
    const oldList = cloneDeep(list);
    const newList = [];
    oldList.forEach((item, index) => {
        const newItem = cloneDeep(item);
        const { name } = newItem;
        if (name.includes(keyword)) {
            newList.push(newItem);
        } else {
            const list =  cloneDeep(newItem.list);
            if (list && list.length) {
                newItem.list = list.filter(el => (el.name || '').includes(keyword));
                if (newItem.list.length) {
                    newList.push(newItem);
                }
            }
        }
    });
    return formatList(newList);
}